import { useCallback, useState } from 'react'

import { config } from '../../../Init/Init'
import { tokenizer } from '../../../../services/utils'
import { usePost } from '../../../../hooks/apiHooks'
import { withdrawalResponseDefaultData } from '../../cryptoPaymentConstants'
import { usePlayerStore } from '../../../../services/store'

export const useSubmitWithdrawal = ({ uuid, loading, setLoading, handleDraftWithdrawalError }) => {
  const playerStore = usePlayerStore()
  const playerUserId = playerStore.use.userId()

  const [withdrawalResponseData, setWithdrawalResponseData] = useState(withdrawalResponseDefaultData)

  const { POST } = usePost()

  const resetWithdrawalResponseData = () => setWithdrawalResponseData(withdrawalResponseDefaultData)

  const onWithdrawalFormSubmit = useCallback(() => {
    if (loading || !uuid) {
      return
    }

    setLoading(true)

    return POST(
      config.paymentsUrl +
        tokenizer(config.submitWithdrawalUrl, {
          '{userId}': playerUserId,
          '{uuid}': uuid
        })
    )
      .then(async response => {
        if (response.errorCode) {
          handleDraftWithdrawalError(response.errorCode)
        } else {
          setWithdrawalResponseData(response.paidCurrency)
        }
      })
      .catch(handleDraftWithdrawalError)
      .finally(() => setLoading(false))
  }, [loading, uuid, setLoading, POST, playerUserId, handleDraftWithdrawalError])

  return { onWithdrawalFormSubmit, withdrawalResponseData, resetWithdrawalResponseData }
}
